import { motion } from 'framer-motion';

const sponsors = [
  'Waikanae Rugby Club',
  'Kapiti Softball Club',
  'Waikanae Lawn Bowls Club A',
  'Waikanae Lawn Bowls Club B',
];

export default function CommunityBanner() {
  return (
    <section style={{ backgroundColor: '#0A0F1C', borderTop: '1px solid rgba(204,0,0,0.2)', borderBottom: '1px solid rgba(204,0,0,0.2)' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <motion.div
          className="text-center mb-10"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, ease: 'easeOut' }}
        >
          <p className="text-xs font-semibold uppercase tracking-widest mb-3" style={{ color: '#CC0000' }}>
            Community
          </p>
          <h2
            className="text-4xl sm:text-5xl font-bold text-white mb-3"
            style={{ fontFamily: "'Barlow Condensed', sans-serif" }}
          >
            Proud to Support Our Community
          </h2>
          <p className="text-gray-400 text-lg">
            Auto Doctor has been part of the Waikanae community for over 20 years.
          </p>
        </motion.div>

        {/* Infinite scroll ticker */}
        <div className="overflow-hidden">
          <motion.div
            className="flex gap-5"
            style={{ width: 'max-content' }}
            animate={{ x: ['0%', '-50%'] }}
            transition={{ duration: 18, ease: 'linear', repeat: Infinity }}
          >
            {[...sponsors, ...sponsors].map((name, i) => (
              <div
                key={i}
                className="flex-shrink-0 px-8 py-4 rounded-xl flex items-center"
                style={{
                  backgroundColor: '#0D1220',
                  border: '1px solid rgba(204,0,0,0.35)',
                  minWidth: '260px',
                }}
              >
                <p
                  className="text-center w-full whitespace-nowrap font-semibold"
                  style={{
                    fontFamily: "'Barlow Condensed', sans-serif",
                    fontSize: '18px',
                    letterSpacing: '0.04em',
                    color: '#CC0000',
                  }}
                >
                  {name}
                </p>
              </div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
}
